module.exports = __webpack_public_path__ + "static/media/logoo.fa42d4f9.jpeg";